import React from 'react'
import { Link } from 'react-router-dom'
import '../../style/InnerDiv.css'
const InnerDiv = (props) =>{

    return (
        <div className = "container">
        <Link  to = {props.Link} className = "text-dark text-decoration-none" >
            <div className = " inner my-5 text-center shadow-lg  mb-5 bg-body py-5">
                <div className = "inner">
                    <img src={props.img} alt=" " className = "rounded-circle shadow-lg mb-4 bg-body " />
                </div>
                <h1 className= "pb-4  inner">{props.h}</h1>
                <p className= "pb-4  text-dark inner">{props.p}</p>
            </div>
        </Link>
        </div>
        
    )
}

export default InnerDiv